import { NgModule } from '@angular/core';
import { CoreLibModule } from 'core-lib';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { PaymentLibRoutingModule } from './payment-lib-routing.module';
import { PaymentLibComponent } from './payment-lib.component';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataViewModule } from 'primeng/dataview';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { PaymentBookingComponent } from './payment-booking/payment-booking.component';
import { PaymentShoppingCartComponent } from './payment-shopping-cart/payment-shopping-cart.component';
import { PaymentWalletComponent } from './payment-wallet/payment-wallet.component';
import { TagModule } from 'primeng/tag';
import {InputTextModule} from "primeng/inputtext";
import {DialogModule} from "primeng/dialog";
import { ToolbarModule } from 'primeng/toolbar';
import { SelectModule } from 'primeng/select';


@NgModule({
  declarations: [
    PaymentLibComponent,
    PaymentBookingComponent,
    PaymentWalletComponent,
    PaymentShoppingCartComponent
  ],
    imports: [
        PaymentLibRoutingModule,
        CommonModule,
        ToastModule,
        FormsModule,
        MessagesModule,
        SelectModule,
        CardModule,
        ButtonModule,
        ProgressSpinnerModule,
        CoreLibModule,
        InputNumberModule,
        DataViewModule,
        TagModule,
        InputTextModule,
        DialogModule,
        ToolbarModule
    ],
  exports: [
    PaymentLibComponent
  ]
})
export class PaymentLibModule { }
